import TokenManager from "../utils/storage/TokenManager";
import { refreshAuthToken } from "../action/AccountActions";

export default api => {

    let isRefreshing = false;
    let refreshSubscribers = [];

    const subscribeTokenRefresh = (cb) => {
        refreshSubscribers.push(cb);
    };

    const onRefreshed = (token) => {
        refreshSubscribers.forEach(cb => cb(token));
        refreshSubscribers = [];
    };

    api.interceptors.response.use(
        res => res,

        async error => {
            const originalRequest = error.config;

            if (error.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;

                const accessToken = await TokenManager.getAccessToken();
                const refreshToken = await TokenManager.getRefreshToken();

                if (!refreshToken) {
                    await TokenManager.removeTokens();
                    return Promise.reject(error);
                }

                if (isRefreshing) {
                    return new Promise(resolve => {
                        subscribeTokenRefresh(token => {
                            originalRequest.headers = {
                                ...originalRequest.headers,
                                Authorization: `Bearer ${token}`,
                            };
                            resolve(api(originalRequest));
                        });
                    });
                }

                isRefreshing = true;

                try {
                    const response = await refreshAuthToken({
                        auth_token: accessToken,
                        refresh_auth_token: refreshToken,
                    });

                    const { auth_token } = response.data.response;

                    await TokenManager.saveTokens(response.data.response);

                    onRefreshed(auth_token);

                    originalRequest.headers = {
                        ...originalRequest.headers,
                        Authorization: `Bearer ${auth_token}`,
                    };

                    return api(originalRequest);

                } catch (e) {
                    return Promise.reject(e);

                } finally {
                    isRefreshing = false;
                }
            }

            return Promise.reject(error);
        }
    );
};
